import { observer } from "mobx-react-lite";
import { useAppStore } from "@/store";
import { EmailSenderObservable } from "@/store/email-senders/EmailSenderObservable";
import {
  MDSText,
  MDSTextVariant,
  MDSButton,
  MDSButtonVariant,
  MDSModalDialog,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSButtonGroup,
} from "@/mds";

type TProps = {
  itemToDelete: EmailSenderObservable | null;
  setItemToDelete: (itemToDelete: EmailSenderObservable | null) => void;
};

export const DeleteItemModal = observer<TProps>(({ itemToDelete, setItemToDelete }) => {
  const { store } = useAppStore();
  const integrationStore = store.emailSenders;

  const isModalOpen = !!itemToDelete;
  const { id } = itemToDelete ?? {};

  const handleCloseModal = () => {
    setItemToDelete(null);
  };

  const handleDeleteItem = () => {
    setItemToDelete(null);

    if (!id) {
      return;
    }

    integrationStore.delete(id);
  };

  return (
    <MDSModalDialog isOpen={isModalOpen} handleClose={handleCloseModal}>
      <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
        Are you sure you want to delete “{itemToDelete?.input ?? "this"}
        ”?
      </MDSText>

      <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
        <MDSText variant={MDSTextVariant.ParagraphS}>
          Deletion is permanent and cannot be undone
        </MDSText>
      </MDSDialogTextContent>

      <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
        <MDSButton onClick={handleCloseModal}>Cancel</MDSButton>
        <MDSButton variant={MDSButtonVariant.DangerFilled} onClick={handleDeleteItem}>
          Delete forever
        </MDSButton>
      </MDSButtonGroup>
    </MDSModalDialog>
  );
});
